import { render, staticRenderFns } from "./FormDadosResidenciais.vue?vue&type=template&id=031e818b&"
import script from "./FormDadosResidenciais.vue?vue&type=script&lang=js&"
export * from "./FormDadosResidenciais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports